import React from 'react'
import { createRoot } from 'react-dom/client'
import { DeliveriesTable } from './components/DeliveriesTable'
import { EndpointsTable } from './components/EndpointsTable'

// Mount points read their settings from data attributes so nothing is interpolated into JS

// <div id="…" data-url="…">
export const startWebhookEndpointsTable = elementId => {
  const element = document.getElementById(elementId)
  createRoot(element).render(<EndpointsTable dataUrl={element.dataset.url} />)
}

// <div id="…" data-url="…" data-limit="…" data-csrf="…">
export const startWebhookDeliveriesTable = elementId => {
  const element = document.getElementById(elementId)
  createRoot(element).render(
    <DeliveriesTable
      dataUrl={element.dataset.url}
      limit={Number(element.dataset.limit)}
      csrfToken={element.dataset.csrf}
    />
  )
}
